import React, { useState, useCallback, useContext } from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const TIMESHEET_APPROVED = [
  { label: 'no', value: 0 },
  { label: 'yes', value: 1 }
];

const ApprovalFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const timesheetApprovedOptions = useTranslatedOptions(TIMESHEET_APPROVED);
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  if (!timesheetApprovedOptions.length || (search && !t('approved').toLowerCase().includes(search.toLowerCase()))) {
    return null;
  }

  return (
    <FilterLayout
      name={t('approved')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {timesheetApprovedOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`approved-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ApprovalFilter;
